<template>
  <main data-test="stylist-confirmation-view" class="stylist-confirmation-view">
    <div class="jm-bg-background jm-py-3">
      <header-prospect>
        <base-title>Merci !</base-title>
        <p
          v-if="!isAlreadyAssigned"
          class="jm-px-3"
          data-test="stylist-message"
        >
          <strong data-test="stylist-firstname"
            >{{ stylist.firstname }}
          </strong>
          va prendre contact avec toi prochainement pour te parler de son
          activité.<br />
          En attendant consulte la brochure explicative.
        </p>
        <p v-else class="jm-px-3" data-test="already-assigned-message">
          Il semble que vous êtes
          <strong>déja en contact avec une Styliste.</strong>
          <br />N'hésitez pas à échanger avec votre Styliste directement.
        </p>
      </header-prospect>

      <section
        v-if="!isAlreadyAssigned"
        class="jm-text-center"
        data-test="stylist-brochure"
      >
        <base-cta
          label="LIRE LA BROCHURE"
          url="https://app.hubspot.com/documents/3296097/view/661528203?accessId=2ecad3"
        ></base-cta>
      </section>
    </div>
    <section
      class="stylist-confirmation-info jm-bg-background-secondary jm-pt-4"
    >
      <div class="jm-justify-center jm-p-4" v-if="!isAlreadyAssigned">
        <stylist-card-simple
          class="jm-mb-3"
          :stylist="stylist"
          data-test="stylist-card-simple"
        ></stylist-card-simple>
      </div>
      <div v-else class="jm-d-flex-center jm-p-4" data-test="siege-contact-cta">
        <base-cta
          class="jm-bg-background jm-py-4 jm-px-3"
          text="Tu peux aussi échanger avec le siège directement en participant à une réunion en ligne pour poser toutes tes questions."
          label="Je réserve un créneau"
          url="https://app.livestorm.co/beauty-blend/devenir-styliste-beaute-jolimoi?type=light"
        ></base-cta>
      </div>
      <div class="jm-d-flex-center jm-pb-4">
        <base-title h="2">À très vite ! ⭐</base-title>
      </div>
    </section>
  </main>
</template>

<script>
import { getAssignedStatus, getSelectedSponsor } from '@/store/store'
import BaseCTA from '@/components/molecules/BaseCTA.vue'
import BaseTitle from '@/components/atoms/BaseTitle.vue'
import HeaderProspect from '@/components/organisms/HeaderProspect.vue'
import StylistCardSimple from '@/components/organisms/StylistCardSimple.vue'

const FOOTER_TEXT =
  'Tu préfères échanger avec l’équipe du siège directement ?<br /> Participe à une réunion en ligne.'
const FOOTER_LABEL_BUTTON = 'Je réserve un créneau'

export default {
  name: 'StylistConfirmationView',
  components: {
    HeaderProspect,
    BaseTitle,
    StylistCardSimple,
    'base-cta': BaseCTA
  },
  data() {
    return {
      stylist: {},
      footerText: FOOTER_TEXT,
      footerLabelButton: FOOTER_LABEL_BUTTON
    }
  },
  computed: {
    isAlreadyAssigned() {
      return getAssignedStatus()
    }
  },
  mounted() {
    this.stylist = getSelectedSponsor()
    if (!this.stylist) {
      this.$router.push({ name: 'contact-form' })
    }
  }
}
</script>
<style lang="scss" scoped>
.stylist-confirmation-view {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.stylist-confirmation-info {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}
</style>
